export enum FiReactionType {
    Like = 0,
    Emoji = 1,
}
